import { FinancialAccountSource, User } from '../api/user/types';

export const userHasExistingRatePlan = (user: User) =>
  user?.financeAccounts?.some((account) => account.source === FinancialAccountSource.lightEnergy);
